import {
  HANDLE_ERROR,
  HANDLE_LOADING,
  AUTH_LOGIN,
  AUTH_REGISTER,
  AUTH_LOGOUT,
} from "./actionTypes";

const initialState = {
  user: null,
  isRegistered: false,
  isLoading: false,
  error: null,
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN:
      return { ...state, user: action.payload, error: null };
    case AUTH_REGISTER:
      return { ...state, isRegistered: action.payload, error: null };
    case HANDLE_LOADING:
      return { ...state, isLoading: action.payload };
    case HANDLE_ERROR:
      return { ...state, error: action.payload };
    case AUTH_LOGOUT:
      return { ...state, user: null };
    default:
      return state;
  }
};

export default reducer;
